import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, Validator } from '@angular/forms';
import  { IpValidationUtils  } from '../validations/ip-validation-utils';
const _ = require('lodash');

@Component({
    selector: 'ip-ranges',
    template: require('./ip-ranges.html'),
    providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IPRanges),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IPRanges),
      multi: true,
    }]
})

export class IPRanges implements ControlValueAccessor, Validator {

    @Input() gateway: any;
    @Input() prefixLength: any;
    @Output() fireValidity = new EventEmitter();
    @Output() dataIpRange = new EventEmitter();
    @Input() readOnly: boolean = false;

    @Input() set ipRanges(ipRanges: any[]) {
        if (ipRanges && ipRanges instanceof Array && ipRanges.length) {
            this.ranges = ipRanges;
        } else {
            this.ranges = [ { valid: true } ];
        }
    };

    private data: any;
    private ranges: any[] = [ { valid: true } ];
    private rangesValue: any[] = [{}];
    private ipValidationUtils: IpValidationUtils = new IpValidationUtils();
    private isValidPrevious: boolean = true;
    private isValid: boolean = true;

    getCurrentValue() {
        let val = _.cloneDeep(this.ranges);
        let result = [];
        val.forEach((r,i) => {
            result[i] = _.pick(r, ['startAddress', 'endAddress']);
        });
        return result;
    }

    constructor() {

    }

    ngOnInit() {
        this.setIndividualRangeValidity();
    }

    ngOnChanges() {
        this.setIndividualRangeValidity();
    }

    writeValue(obj: any) {
        if (obj) {
            this.data = obj;
            this.ipRanges = this.data;
        }
    }

    // registers 'fn' that will be fired wheb changes are made
    // this is how we emit the changes back to the form
    public registerOnChange(fn: any) {
    }

    // validates the form, returns null when valid else the validation object
    // in this case we're checking if the json parsing has passed or failed from the onChange method
    public validate(c: FormControl) {
        return (this.isValid) ? null : {
            ipRangeError: {
                valid: false,
            },
        };
    }

    // not used, used for touch input
    public registerOnTouched() { }

    setIndividualRangeValidity() {
        if (this.ranges.length === 0 || !this.ranges[0].startAddress || !this.gateway || !this.prefixLength) {
            return;
        } else if (typeof this.gateway === "string") {
            for (let i = 0 ; i < this.ranges.length; i++) {
                this.ranges[i].valid = true;
                if ( !this.ipValidationUtils.isRangeValid(this.ranges[i].startAddress,
                        this.ranges[i].endAddress, this.gateway, this.prefixLength) ) {
                    this.ranges[i].valid = false;
                } else {
                    for (let j = 0; j < i; j++) {
                        if (this.ipValidationUtils.areRangesOverlapping(this.ranges[i], this.ranges[j])) {
                            this.ranges[i].valid = false;
                            break;
                        }
                    }
                }
            }
        } else {
            let gateways = this.gateway;
            for (let i = 0 ; i < this.ranges.length; i++) {
                this.ranges[i].valid = true;
                for (let j = 0; j < gateways.length; j++) {
                    if (!this.ipValidationUtils.isRangeValid(this.ranges[i].startAddress,
                            this.ranges[i].endAddress, gateways[j], this.prefixLength) ) {
                        this.ranges[i].valid = false;
                        this.isValidPrevious = this.isValid;
                        this.isValid = false;
                    } else {
                        for (let j = 0; j < i; j++) {
                            if (this.ipValidationUtils.areRangesOverlapping(this.ranges[i], this.ranges[j])) {
                                this.ranges[i].valid = false;
                                break;
                            }
                        }
                    }
                }
            }
        }

        this.isValidPrevious = this.isValid;
        for (let i=0; i<this.ranges.length; ++i) {
            if (this.ranges[i].valid) {
                this.isValid = true;
            } else {
                this.isValid = false;
                break;
            }
        }
        if (this.isValid === true || this.isValid !== this.isValidPrevious) {
            this.fireValidity.emit({
                valid: this.isValid
            });
        }
    }

    save(event, index: number) {
        let value = event.target.value;
        if (!value) {
            this.remove(event, index);
            return;
        }
        let range = {};
        let ipRangeArr: string[] = value.split('-', 2);
        let startAddress = ipRangeArr[0].trim();
        let endAddress = '';
        if ( ipRangeArr.length > 1 ) {
            endAddress = ipRangeArr[1].trim();
        } else {
            if (this.ipValidationUtils.isIpValid(startAddress)) {
                endAddress = startAddress;
            }
        }
        this.ranges[index] = { startAddress: startAddress, endAddress: endAddress, valid: true };
        this.setIndividualRangeValidity();
        if (!this.isValid) {
            return;
        }
        this.rangesValue = this.getCurrentValue();
        this.dataIpRange.emit({data: this.ranges});
    }

    getRange(ipRange: any) {
        let rangeValue: string = '';
        if (ipRange.hasOwnProperty('startAddress')) {
            rangeValue = ipRange.startAddress;
            if (ipRange.endAddress !== '') {
                rangeValue = ipRange.startAddress + ' - ' + ipRange.endAddress;
            }
        }
        return rangeValue;
    }

    add(event, i: number, value: any) {
        // new IP range is added, disable save button
        this.ranges.push({valid: false});
        this.fireValidity.emit({
            valid: false
        });
        // this.save(event, i);
    }

    remove(event, i: number) {
        this.ranges.splice(i, 1);
        if (this.ranges.length === 0 && this.gateway && this.prefixLength) {
            // all items are removed, disable save button
            this.fireValidity.emit({
                valid: false
            });
            return;
        }
        this.setIndividualRangeValidity();
        if (!this.isValid) {
            return;
        }
        this.rangesValue = this.getCurrentValue();
        this.dataIpRange.emit({data: this.ranges});
    }
}



// WEBPACK FOOTER //
// ./src/common/ip-ranges/ip-ranges.component.ts